import { AudioType } from './AudioType.ts';
import SFXDiceRoll1 from '@static/audio/compressed/sfx_dice_roll_1.mp3';
import SFXDiceRoll2 from '@static/audio/compressed/sfx_dice_roll_2.mp3';
import SFXDiceRoll3 from '@static/audio/compressed/sfx_dice_roll_3.mp3';
import SFXDiceRoll4 from '@static/audio/compressed/sfx_dice_roll_4.mp3';
import SFXYourTurn from '@static/audio/compressed/sfx_your_turn.mp3';
import SFXFirstReminder from '@static/audio/compressed/sfx_first_reminder.mp3';
import SFXRoadPlace from '@static/audio/compressed/sfx_road_place.mp3';
import SFXSettlementPlace from '@static/audio/compressed/sfx_settlement_place.mp3';
import SFXCityPlace from '@static/audio/compressed/sfx_city_place.mp3';
import SFXShipPlace from '@static/audio/compressed/sfx_ship_place.mp3';
import SFXShipMove from '@static/audio/compressed/sfx_ship_move.mp3';
import SFXMetropolisPlace from '@static/audio/compressed/sfx_metropolis_place.mp3';
import SFXCityWallPlace from '@static/audio/compressed/sfx_city_wall_place.mp3';
import SFXCityDestroy from '@static/audio/compressed/sfx_city_destroy.mp3';
import SFXCityImprovement from '@static/audio/compressed/sfx_city_improvement.mp3';
import SFXRobberPlace from '@static/audio/compressed/sfx_robber_place.mp3';
import SFXPiratePlace from '@static/audio/compressed/sfx_pirate_place.mp3';
import SFXVoteReminder from '@static/audio/compressed/sfx_vote_reminder.mp3';
import SFXOfferAcceptable from '@static/audio/compressed/sfx_offer_acceptable.mp3';
import SFXOfferNotAcceptable from '@static/audio/compressed/sfx_offer_not_acceptable.mp3';
import SFXOfferAccepted from '@static/audio/compressed/sfx_offer_accepted.mp3';
import SFXOfferRejected from '@static/audio/compressed/sfx_offer_rejected.mp3';
import SFXClockTick from '@static/audio/compressed/sfx_clock_tick.mp3';
import SFXKnightEquip from '@static/audio/compressed/sfx_knight_equip.mp3';
import SFXKnightPlace from '@static/audio/compressed/sfx_knight_place.mp3';
import SFXKnightUpgrade from '@static/audio/compressed/sfx_knight_upgrade.mp3';
import SFXDiscardBroadcast from '@static/audio/compressed/sfx_discard_broadcast.mp3';
import SFXDiscardNotification from '@static/audio/compressed/sfx_discard_notification.mp3';
import SFXClick from '@static/audio/compressed/sfx_click.mp3';
import SFXMessageNotification from '@static/audio/compressed/sfx_message_notification.mp3';
import SFXJoinRoom from '@static/audio/compressed/sfx_join_room.mp3';
import SFXLeaveRoom from '@static/audio/compressed/sfx_leave_room.mp3';
import SFXRoomSettingUpdated from '@static/audio/compressed/sfx_room_setting_updated.mp3';
import SFXRoomGetReady from '@static/audio/compressed/sfx_room_get_ready.mp3';
import SFXAchievementCkProgress from '@static/audio/compressed/sfx_achievement_ck_progress.mp3';
import SFXAchievementLargestArmy from '@static/audio/compressed/sfx_achievement_largest_army.mp3';
import SFXAchievementLongestRoad from '@static/audio/compressed/sfx_achievement_longest_road.mp3';
import SFXGameStarted from '@static/audio/compressed/sfx_game_started.mp3';
import SFXGameStartedGuitar from '@static/audio/compressed/sfx_game_started_guitar.mp3';
import SFXSettlementPhaseEnded from '@static/audio/compressed/sfx_settlement_phase_ended.mp3';
import SFXSettlementPhaseEndedGuitar from '@static/audio/compressed/sfx_settlement_phase_ended_guitar.mp3';
import SFXVictory from '@static/audio/compressed/sfx_victory.mp3';
import SFXReconnect from '@static/audio/compressed/sfx_reconnect.mp3';
import SFXDisconnect from '@static/audio/compressed/sfx_disconnect.mp3';
import SFXBeginnerHintActivated from '@static/audio/compressed/sfx_beginner_hint_activated.mp3';
import SFXDevCardBought from '@static/audio/compressed/sfx_devcard_bought.mp3';
import SFXDevCardUsed from '@static/audio/compressed/sfx_devcard_used.mp3';
import SFXDevCardMonopoly from '@static/audio/compressed/sfx_devcard_monopoly.mp3';
export const AUDIO_FILES = {
    [AudioType.DiceRoll1]: SFXDiceRoll1,
    [AudioType.DiceRoll2]: SFXDiceRoll2,
    [AudioType.DiceRoll3]: SFXDiceRoll3,
    [AudioType.DiceRoll4]: SFXDiceRoll4,
    [AudioType.YourTurn]: SFXYourTurn,
    [AudioType.FirstReminder]: SFXFirstReminder,
    [AudioType.RoadPlace]: SFXRoadPlace,
    [AudioType.SettlementPlace]: SFXSettlementPlace,
    [AudioType.CityPlace]: SFXCityPlace,
    [AudioType.ShipPlace]: SFXShipPlace,
    [AudioType.ShipMove]: SFXShipMove,
    [AudioType.MetropolisPlace]: SFXMetropolisPlace,
    [AudioType.CityWallPlace]: SFXCityWallPlace,
    [AudioType.CityDestroy]: SFXCityDestroy,
    [AudioType.CityImprovement]: SFXCityImprovement,
    [AudioType.RobberPlace]: SFXRobberPlace,
    [AudioType.PiratePlace]: SFXPiratePlace,
    [AudioType.VoteReminder]: SFXVoteReminder,
    [AudioType.OfferAcceptable]: SFXOfferAcceptable,
    [AudioType.OfferNotAcceptable]: SFXOfferNotAcceptable,
    [AudioType.OfferAccepted]: SFXOfferAccepted,
    [AudioType.OfferRejected]: SFXOfferRejected,
    [AudioType.ClockTick]: SFXClockTick,
    [AudioType.KnightEquip]: SFXKnightEquip,
    [AudioType.KnightPlace]: SFXKnightPlace,
    [AudioType.KnightUpgrade]: SFXKnightUpgrade,
    [AudioType.DiscardBroadcast]: SFXDiscardBroadcast,
    [AudioType.DiscardNotification]: SFXDiscardNotification,
    [AudioType.Click]: SFXClick,
    [AudioType.MessageNotification]: SFXMessageNotification,
    [AudioType.JoinRoom]: SFXJoinRoom,
    [AudioType.LeaveRoom]: SFXLeaveRoom,
    [AudioType.RoomSettingUpdated]: SFXRoomSettingUpdated,
    [AudioType.RoomGetReady]: SFXRoomGetReady,
    [AudioType.AchievementCKProgress]: SFXAchievementCkProgress,
    [AudioType.AchievementLargestArmy]: SFXAchievementLargestArmy,
    [AudioType.AchievementLongestRoad]: SFXAchievementLongestRoad,
    [AudioType.GameStarted]: SFXGameStarted,
    [AudioType.GameStartedGuitar]: SFXGameStartedGuitar,
    [AudioType.SettlementPhaseEnded]: SFXSettlementPhaseEnded,
    [AudioType.SettlementPhaseEndedGuitar]: SFXSettlementPhaseEndedGuitar,
    [AudioType.Victory]: SFXVictory,
    [AudioType.Reconnect]: SFXReconnect,
    [AudioType.Disconnect]: SFXDisconnect,
    [AudioType.BeginnerHintActivated]: SFXBeginnerHintActivated,
    [AudioType.DevelopmentCardBought]: SFXDevCardBought,
    [AudioType.DevelopmentCardUsed]: SFXDevCardUsed,
    [AudioType.DevelopmentCardMonopoly]: SFXDevCardMonopoly
};
